import { render, staticRenderFns } from "./commonWords.vue?vue&type=template&id=6d7505b9&scoped=true"
import script from "./commonWords.vue?vue&type=script&lang=ts"
export * from "./commonWords.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7505b9",
  null
  
)

export default component.exports